import Vue from 'vue'
import App from './App.vue'
import "./assets/app.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fa';
import "./registerServiceWorker";


locale.el.colorpicker.confirm='تایید'

Vue.use(ElementUI, {locale});
Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
